var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{staticClass:"test_radioinput",attrs:{"type":"radio","name":"question"},domProps:{"value":_vm.answer},on:{"change":function($event){_vm.selectAnswer($event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"test_radioinput_custom"}),_vm._v(" "),_c('div',{staticClass:"test_question_answer"},[_vm._v(_vm._s(_vm.answer))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4237c3de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnswerOption.vue
// module id = null
// module chunks = 